<h1 mat-dialog-title>{{ data.title }}</h1>
<form [formGroup]="data.form.form" (ngSubmit)="onSubmit()">
  <div mat-dialog-content>
    <app-form-fields [formData]="data.form"></app-form-fields>
  </div>
  <div mat-dialog-actions>
    <ub-button-list>
      <button *ngIf="shouldShowButton('submit')"
              mat-flat-button
              color="primary"
              type="submit"
              [disabled]="submitted" i18n>Save</button>
      <button *ngIf="shouldShowButton('cancel')"
              mat-flat-button
              color="warn"
              [mat-dialog-close]="" i18n>Cancel</button>
    </ub-button-list>
  </div>
</form>
